module.exports = __webpack_public_path__ + "img/vc-benchmarking.49016763.png";